import React, { useRef } from 'react';
import Select2 from 'react-select';

const CustomSelect = React.forwardRef(({ list, defaultValue, value, multi = false, isDisabled, handleChange }, ref) => {
    const selectInputRef = useRef(null);

    function shouldUseAutoComplete(list) {
        return list > 400;
    }

    function clear() {
        selectInputRef.current.select.clearValue();
    };

    const customStyles = {
        input: (provided, state) => ({
            ...provided,
            cursor: 'text'
        }),
        option: (provided, state) => ({
            ...provided,
            cursor: 'pointer'
        })
    }

    const dv = value ? list?.find(x => x.value === value) : null;

    return (
        <Select2
            ref={ref}
            value={dv}
            placeholder={shouldUseAutoComplete(list.length) ? 'Busque' : 'Selecione'}
            isMulti={multi}
            isDisabled={isDisabled}
            defaultValue={defaultValue}
            defaultOptions={true}
            options={list}
            styles={customStyles}

            noOptionsMessage={() => "Nenhuma opção encontrada"}
            openMenuOnClick={list && !shouldUseAutoComplete(list.length)}
            onChange={event => handleChange(event)}
        />
    )
});

export default CustomSelect;